// CMP-0140 · LFS Error page · Catalog Engine · Lot Discovery · owner: Platform
// 99-1: /Users/yogeshmathur/ym/lot-for-sale-ph/docs/design-handoff/README.md
// 99-1-decision: ADAPT the approved Concept D Not Found.dc.html "Something went wrong" state as Next.js error boundary; reload retries the render, contact opens the inquiry popup
"use client"

import { Button } from "@/components/ui/button"
import { Icon } from "@/components/lfs/primitives"
import { INQUIRE } from "@/lib/lfs/catalog"

export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="lfs-section" style={{ minHeight: "60vh", display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <div role="alert" style={{ maxWidth: 820, width: "100%", margin: "0 auto" }}>
        <Icon name="cloud_off" size={40} color="#1A5CF0" />
        <h1 className="lfs-h1" style={{ marginTop: 12, fontSize: "clamp(30px,3.6vw,48px)" }}>Something went wrong on our side</h1>
        <p className="lfs-lede">Please try again in a moment. If you were sending an inquiry, it may not have gone through — please send it again.</p>
        <div style={{ marginTop: 24, display: "flex", flexWrap: "wrap", gap: 8 }}>
          <Button type="button" onClick={() => reset()} className="lfs-btn-accent" style={{ height: 48, padding: "0 18px", borderRadius: 12, font: "inherit", fontWeight: 600 }}><Icon name="refresh" size={20} />Reload page</Button>
          <a href={INQUIRE.general} style={{ height: 48, padding: "0 18px", borderRadius: 12, border: "1px solid #E2E6EC", display: "flex", alignItems: "center", gap: 8, fontWeight: 600, textDecoration: "none" }}><Icon name="forum" size={20} />Contact us</a>
        </div>
      </div>
    </div>
  )
}
